var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.pageTitle}}),_vm._v(" "),_c('app-tab',{staticClass:"job-setting-tab",attrs:{"tabs":_vm.tabsVertical,"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }